import {Modal as BaseModal} from 'react-native';

export default BaseModal;
